module.exports = __webpack_public_path__ + "img/cp-17.a340bc97.jpg";